import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatEUR } from "@/lib/api";
import { MobileShell, CustomerBottomNav } from "@/components/Shell";
import { Trophy, Medal } from "lucide-react";

export default function Leaderboard() {
  const [staff, setStaff] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [tab, setTab] = useState("staff");

  useEffect(() => {
    api.get("/leaderboards/staff").then((r) => setStaff(r.data));
    api.get("/leaderboards/customers").then((r) => setCustomers(r.data));
  }, []);

  const list = tab === "staff" ? staff : customers;

  return (
    <MobileShell>
      <div className="px-5 pt-10 pb-4">
        <Link to="/" className="text-xs text-[#A1A1AA] tracking-[0.2em] uppercase">← Zurück</Link>
        <h1 className="text-4xl font-black tracking-tight mt-6 flex items-center gap-3">
          <Trophy className="w-8 h-8 text-[#EBB300]" /> Leaderboard
        </h1>
        <p className="text-[#A1A1AA] mt-2">Die Top-Performer der Saison.</p>
      </div>

      <div className="px-5">
        <div className="bg-[#121216] border border-white/5 rounded-full p-1 flex gap-1" data-testid="leaderboard-tabs">
          <button onClick={() => setTab("staff")} data-testid="leaderboard-tab-staff"
            className={`flex-1 py-2.5 rounded-full text-sm font-semibold transition-all ${tab === "staff" ? "bg-[#EBB300] text-[#0A0A0C]" : "text-[#A1A1AA]"}`}>
            Service
          </button>
          <button onClick={() => setTab("customers")} data-testid="leaderboard-tab-customers"
            className={`flex-1 py-2.5 rounded-full text-sm font-semibold transition-all ${tab === "customers" ? "bg-[#EBB300] text-[#0A0A0C]" : "text-[#A1A1AA]"}`}>
            Gäste
          </button>
        </div>
      </div>

      {/* Podium for top 3 */}
      {list.length >= 3 && (
        <div className="px-5 mt-8 grid grid-cols-3 items-end gap-3" data-testid="leaderboard-podium">
          {[1, 0, 2].map((idx) => {
            const item = list[idx];
            const positions = { 0: { h: "h-32", color: "#EBB300", label: "1" }, 1: { h: "h-24", color: "#A1A1AA", label: "2" }, 2: { h: "h-20", color: "#E05A33", label: "3" } };
            const p = positions[idx];
            return (
              <div key={idx} className="text-center">
                <div className="mb-2 text-sm font-bold truncate" data-testid={`podium-${idx}-name`}>{item.name}</div>
                <div className="text-xs font-black mb-2" style={{ color: p.color }}>{formatEUR(item.total)}</div>
                <div className={`${p.h} rounded-t-xl flex items-center justify-center text-3xl font-black`}
                  style={{ background: `linear-gradient(180deg, ${p.color}40 0%, ${p.color}10 100%)`, border: `1px solid ${p.color}40` }}>
                  <span style={{ color: p.color }}>{p.label}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Full list */}
      <div className="px-5 mt-8 pb-10 space-y-2" data-testid="leaderboard-list">
        {list.length === 0 && <div className="text-center text-sm text-[#A1A1AA] py-10">Noch keine Daten.</div>}
        {list.map((item, i) => (
          <div key={item.staff_id || item.customer_id} className="flex items-center gap-4 bg-[#121216] border border-white/5 rounded-2xl p-4">
            <div className={`w-9 h-9 rounded-full flex items-center justify-center font-black text-sm ${i === 0 ? "bg-[#EBB300] text-[#0A0A0C]" : i === 1 ? "bg-white/10 text-white" : i === 2 ? "bg-[#E05A33]/20 text-[#E05A33]" : "bg-[#0A0A0C] text-[#A1A1AA]"}`}>
              {i < 3 ? <Medal className="w-4 h-4" /> : i + 1}
            </div>
            {item.photo_url && <img src={item.photo_url} alt="" className="w-10 h-10 rounded-full object-cover" />}
            <div className="flex-1 min-w-0">
              <div className="font-bold truncate">{item.name}</div>
              <div className="text-xs text-[#A1A1AA]">{item.count} Trinkgelder</div>
            </div>
            <div className="text-lg font-black text-[#EBB300]">{formatEUR(item.total)}</div>
          </div>
        ))}
      </div>

      <CustomerBottomNav />
    </MobileShell>
  );
}
